'use client';

import { useState } from 'react';
import { Maximize2, Minimize2, ExternalLink } from 'lucide-react';
import { colors, typography } from '@/styles/theme';
import { Button } from '@/components/ui/button';
import { useTranslation } from '@/hooks/useTranslation';

/**
 * 业务流程图 — 自绘轨道图（flow-renderer 渲染 robot-lifecycle.yaml）
 * 源：docs/modules/robot-manager/business-analysis/robot-lifecycle.html
 * 部署时复制到 public/docs/robot-manager/robot-lifecycle.html。
 *
 * 配套：v3 数据分层方案 + 字段设计 + STAGE_TRANSITIONS。沟通时直接 share 这个页面 URL。
 */
export default function WorkflowPage() {
  const { t } = useTranslation();
  const [fullscreen, setFullscreen] = useState(false);
  const src = '/docs/robot-manager/robot-lifecycle.html';

  return (
    <div
      className={fullscreen ? 'fixed inset-0 z-50' : 'h-full'}
      style={{ backgroundColor: colors.bgPrimary }}
    >
      <div
        className="border-b px-6 h-12 flex items-center justify-between"
        style={{ borderColor: colors.border }}
      >
        <div>
          <h1 className={typography.h4}>{t.robotManager.nav.workflow}</h1>
          <span className={`${typography.caption} ml-3`}>
            采购 → 物流 → 仓储/PDI/改装 → 销售 → 交付 → 售后/租赁 三流程轨道图 · 28 节点
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={() => window.open(src, '_blank')}>
            <ExternalLink className="w-4 h-4 mr-1" />
            新标签页打开
          </Button>
          <Button variant="outline" size="sm" onClick={() => setFullscreen((f) => !f)}>
            {fullscreen ? (
              <>
                <Minimize2 className="w-4 h-4 mr-1" />
                退出全屏
              </>
            ) : (
              <>
                <Maximize2 className="w-4 h-4 mr-1" />
                全屏
              </>
            )}
          </Button>
        </div>
      </div>

      <iframe
        src={src}
        title="Robot Manager v3 Workflow"
        className="w-full"
        style={{ height: fullscreen ? 'calc(100vh - 3rem)' : 'calc(100% - 3rem)', border: 'none' }}
      />
    </div>
  );
}
